import { connect } from 'react-redux';
import ByFollowCallStatus from '../components/OrderDashboardPages/pages/ByFollowCallStatus';
import { getUser as getUserSelector } from '../redux/selectors/accountSettingSelector';
import { getCurrentPersonAllStatus } from '../redux/actions/CurrentPersonStatus';
import { getUser } from '../redux/actions/AccountSetting';
import { goBack, push } from "react-router-redux";

const mapStateToProps = (state) => ({
  user: getUserSelector(state),
  lists: state.currentPersonStatus.currentStatusLists,
  pageInfo: state.currentPersonStatus.pageInfoCurrentPersonStatuses,
  isLoading: (typeof state.currentPersonStatus.isLoadingCurrentPersonStatuses === "object" && Object.keys(state.currentPersonStatus.isLoadingCurrentPersonStatuses).length > 0) ? Object.values(state.currentPersonStatus.isLoadingCurrentPersonStatuses).some(item => item === true) : true,
})

const mapDispatchToProps = dispatch => ({
  getCurrentPersonAllStatus(data) {
    dispatch(getCurrentPersonAllStatus(data))
  },

  getUserInfo() {
    dispatch(getUser());
  },

  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ByFollowCallStatus);



// WEBPACK FOOTER //
// ./src/containers/ByFollowCallStatus.js